import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ThinLayout } from "../Layouts/ThinLayout";
import { Alert } from "@mui/material";

export const OAuth = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"processing" | "success" | "error">(
    "processing",
  );

  const state = searchParams.get("state");
  const code = searchParams.get("code");
  const platform = searchParams.get("platform");
  const error = searchParams.get("error");

  useEffect(() => {
    const handleOAuthCallback = () => {
      // Check if there's an error from the OAuth provider
      if (error) {
        setStatus("error");
        window.opener?.postMessage(
          {
            type: "OAUTH_ERROR",
            error: error,
          },
          "*",
        );
        return;
      }

      // For Moodle, immediately signal success since it doesn't use OAuth
      if (platform === "moodle") {
        setStatus("success");
        window.opener?.postMessage(
          {
            type: "OAUTH_SUCCESS",
            platform: "moodle",
          },
          "*",
        );
        setTimeout(() => window.close(), 1000);
        return;
      }

      // For other platforms, pass the code and state to the parent window
      if (code && state) {
        setStatus("success");
        window.opener?.postMessage(
          {
            type: "OAUTH_SUCCESS",
            code: code,
            state: state,
            platform: platform,
          },
          "*",
        );
        setTimeout(() => window.close(), 1000);
      } else {
        setStatus("error");
        window.opener?.postMessage(
          {
            type: "OAUTH_ERROR",
            error: "Missing authorization code or state",
          },
          "*",
        );
      }
    };

    handleOAuthCallback();
  }, [code, state, platform, error]);

  return (
    <ThinLayout title={"Please wait"} loading={status === "processing"}>
      <>
        {status === "error" ? (
          <Alert severity="error">
            We were unable to complete your connection to the LMS. Please try
            again later.
          </Alert>
        ) : status === "success" ? (
          <Alert
            severity="success"
            sx={{
              backgroundColor: "#4caf50",
              color: "white",
              "& .MuiAlert-icon": {
                color: "white",
              },
            }}
          >
            Success! This window will close momentarily.
          </Alert>
        ) : (
          <></>
        )}
      </>
    </ThinLayout>
  );
};
